<template>
  <div class="home-page">
    <section class="company-information">
      <template v-if="homePage.companyProfile">
        <section v-html="homePage.companyProfile"></section>
      </template>
    </section>
    <section class="features-container">
      <div class="page-content">
        <section class="feature" v-for="feature in features" :key="feature.key">
          <p class="title">{{ feature.title }}</p>
          <p class="subtitle">{{ feature.subtitle }}</p>
          <img :src="feature.icon" alt="" class="icon" />
        </section>
      </div>
    </section>
    <section class="broker-services-container page-content">
      <section class="module__header">
        <h2 class="module__header__title">经纪人服务</h2>
        <p class="module__header__subtitle">Broker Services</p>
      </section>
      <section class="brokers-container">
        <section
          class="broker"
          v-for="broker in brokers"
          :key="broker.practiceNumber"
        >
          <div class="avatar">
            <img :src="broker.avatar" alt="" />
          </div>
          <p class="name">{{ broker.name }}</p>
          <p class="work-years">从业{{ broker.workYears }}年</p>
          <section class="evaluation">
            <section class="good-feedback-rate">
              <p class="value">{{ broker.goodFeedbackRate }}</p>
              <p class="label">好评率</p>
            </section>
            <section class="client-count">
              <p class="value">{{ broker.clientCount }}</p>
              <p class="label">服务用户数</p>
            </section>
          </section>
          <p class="practice-number">执业编号：{{ broker.practiceNumber }}</p>
        </section>
      </section>
    </section>
    <section class="risk-warning" @click="updateModalVisible(true)">
      <template v-if="homePage.riskWarning">
        <section v-html="homePage.riskWarning"></section>
      </template>
    </section>
    <modal
      v-bind="modalProps"
      title="风险提示"
      @change="updateModalVisible"
      v-model="modalProps.visible"
    >
      <section v-html="homePage.riskWarningDetail"></section>
    </modal>
  </div>
</template>

<script>
import Modal, { modalMixin } from "@/components/modal";
import { get } from "lodash";
export default {
  name: "home-page",
  components: { Modal },
  mixins: [modalMixin],
  data() {
    return {
      homePage: {},
      features: [
        {
          title: "保障安心",
          subtitle: "专注定制高性价比保险产品安心",
          key: "baozhanganxin",
          icon:
            "https://static.soyoung.com/sy-pre/baozhanganxin-1682385000719.png",
        },
        {
          title: "投保省心",
          subtitle: "互联网投保 5分钟完成购买",
          key: "toubaoshenxin",
          icon:
            "https://static.soyoung.com/sy-pre/toubaoshenxin-1682385000719.png",
        },
        {
          title: "理赔放心",
          subtitle: "1对1管家服务 一键理赔",
          key: "lipeifangxin",
          icon:
            "https://static.soyoung.com/sy-pre/lipeifangxin-1682385000719.png",
        },
      ],
      brokers: [
        {
          name: "金晓兵",
          workYears: 20,
          goodFeedbackRate: 100,
          clientCount: "1000+",
          practiceNumber: "26066100000080062021000192",
          avatar:
            "https://static.soyoung.com/sy-pre/jinxiaobin-1682406600722.png",
        },
        {
          name: "王磷",
          workYears: 1,
          goodFeedbackRate: 100,
          clientCount: "1000+",
          practiceNumber: "26066100000080062020000033",
          avatar: "https://static.soyoung.com/sy-pre/wanglin-1682406600722.png",
        },
        {
          name: "谢芳英",
          workYears: 2,
          goodFeedbackRate: 100,
          clientCount: "1000+",
          practiceNumber: "26066100000080062019000020",
          avatar:
            "https://static.soyoung.com/sy-pre/xiefangyin-1682406600722.png",
        },
      ],
      modalVisible: false,
    };
  },
  created() {
    this.getHomePage();
  },
  methods: {
    getHomePage() {
      this.$get("/base/official-site/anonymous/home-page")
        .then((res) => {
          const data = get(res, "data");
          if (data) {
            this.homePage = data;
          }
        })
        .catch((error) => {});
    },
  },
};
</script>

<style lang="less">
.home-page {
  .company-information,
  .risk-warning {
    width: 100%;
    p {
      img {
        width: 100%;
      }
      br {
        display: none;
      }
    }
  }
  .company-information {
    min-height: 364px;
    background: #f6fafe;
  }
  .risk-warning {
    cursor: pointer;
  }
  .features-container {
    background: #f6fafe;
    padding: 107px 0 80px;
    .page-content {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .feature {
        background-image: linear-gradient(-85deg, #f2f6fc 8%, #eff5ff 98%);
        box-shadow: -4px -4px 10px 0 rgba(255, 255, 255, 0.73),
          4px 4px 10px 0 rgba(206, 220, 243, 0.55);
        box-sizing: border-box;
        padding: 62px 40px;
        width: 386px;
        position: relative;
        z-index: 1;
        .title {
          font-family: PingFangSC-Medium;
          font-size: 22px;
          color: #121519;
          letter-spacing: 0;
          font-weight: bold;
          line-height: 30px;
          padding-bottom: 8px;
        }
        .subtitle {
          font-family: PingFangSC-Regular;
          font-size: 18px;
          color: #53595f;
          letter-spacing: 0;
          text-align: justify;
        }
        .icon {
          width: 106px;
          height: 106px;
          position: absolute;
          right: 10px;
          top: -27px;
        }
      }
    }
  }
  .broker-services-container {
    padding: 80px 0 64px;
    box-sizing: border-box;
  }
  .brokers-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 40px;
    .broker {
      width: 288px;
      padding: 16px 10px;
      box-sizing: border-box;
      background-image: linear-gradient(179deg, #f6faff 4%, #ffffff 100%);
      box-shadow: 0 10px 30px 0 rgba(135, 164, 208, 0.2);
      .avatar {
        width: 164px;
        height: 164px;
        margin: 0 auto;
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .name {
        font-family: PingFangSC-Medium;
        font-size: 22px;
        line-height: 30px;
        color: #121519;
        letter-spacing: 0;
        text-align: center;
        padding-top: 12px;
        padding-bottom: 4px;
      }
      .work-years {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        line-height: 17px;
        color: #53595f;
        letter-spacing: 0;
        text-align: center;
      }
      .evaluation {
        padding: 24px 0 16px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        section {
          width: 132px;
          padding: 10px 0;
          box-sizing: border-box;
          &.good-feedback-rate {
            background-image: linear-gradient(
              180deg,
              rgba(0, 186, 108, 0.06) 28%,
              rgba(0, 186, 108, 0) 100%
            );
            border-radius: 7px;
            .value {
              color: #00ba6c;
            }
          }
          &.client-count {
            background-image: linear-gradient(
              180deg,
              rgba(0, 68, 193, 0.06) 28%,
              rgba(0, 68, 193, 0) 100%
            );
            border-radius: 7px;
            .value {
              color: #0044c1;
            }
          }
          .value {
            font-family: DIN-Medium;
            font-size: 18px;
            letter-spacing: 0;
            text-align: justify;
            line-height: 22px;
            padding-bottom: 2px;
            text-align: center;
          }
          .label {
            font-size: 14px;
            color: #121519;
            letter-spacing: 0;
            text-align: center;
            line-height: 20px;
          }
        }
      }
      .practice-number {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        line-height: 17px;
        color: #9ca4b0;
        letter-spacing: 0;
        text-align: center;
      }
    }
  }
}
@media all and (max-width: 1200px) {
  .home-page {
    .features-container {
      padding: 50px 10px;
      .page-content {
        flex-direction: column;
        .feature + .feature {
          margin-top: 40px;
        }
      }
    }
    .broker-services-container {
      padding: 60px 0;
    }
    .brokers-container {
      flex-direction: column;
      .broker + .broker {
        margin-top: 20px;
      }
    }
  }
}
</style>
